'use strict';
var $export = require('./_export')
  , $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/core-js/modules/es6.array.reduce-right.js
// module id = ../../../../core-js/modules/es6.array.reduce-right.js
// module chunks = 0